import type { AuthSessionData } from '../../platform-types/src'
import { AUTH_LOGOUT_PATH, AUTH_SESSION_PATH, DEFAULT_API_BASE } from '../../config/src'

export async function fetchAuthSession(apiBase: string = DEFAULT_API_BASE): Promise<AuthSessionData | null> {
  const response = await fetch(`${apiBase}${AUTH_SESSION_PATH}`, {
    credentials: 'include',
  })

  if (response.status === 401) {
    return null
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to load auth session' }))
    throw new Error(error.detail || `HTTP ${response.status}`)
  }

  return response.json()
}

export async function logoutAuthSession(apiBase: string = DEFAULT_API_BASE): Promise<void> {
  await fetch(`${apiBase}${AUTH_LOGOUT_PATH}`, {
    method: 'POST',
    credentials: 'include',
  })
}
